import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { SmartRenderer } from '../../../../fc-core/src/component-interface';
import { pluck, hiddenStr, pluckNumber } from '../../../../fc-core/src/lib';
import { isMacro, solveEquation, parseEquation, cleanMacro, getScaledVal } from '../utils';

var AnnotationBase =
/*#__PURE__*/
function (_SmartRenderer) {
  _inherits(AnnotationBase, _SmartRenderer);

  function AnnotationBase() {
    var _this;

    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AnnotationBase);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnnotationBase).call(this)), 'string' == typeof a && _this.setId(a), _this.rawConfig = JSON.parse(JSON.stringify(a)), _this.store = {};
    return _this;
  }

  _createClass(AnnotationBase, [{
    key: "getType",
    value: function getType() {
      return this._getConfig('type');
    }
  }, {
    key: "_setToStore",
    value: function _setToStore(a, b) {
      this.store[a] = b;
    }
  }, {
    key: "_getFromStore",
    value: function _getFromStore(a) {
      return this.store[a];
    }
  }, {
    key: "_setConfig",
    value: function _setConfig(a, b) {
      this.config[a] = b;
    }
  }, {
    key: "_getConfig",
    value: function _getConfig() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return '' === a ? this.config : this.config[a];
    }
  }, {
    key: "getElement",
    value: function getElement() {
      var a = this,
          b = a.config;
      return this.getGraphicalElement(b.id, b.animationLabel);
    }
  }, {
    key: "getBounds",
    value: function getBounds() {
      return this.getElement().getBBox();
    }
  }, {
    key: "data",
    value: function data(a, b) {
      var c = this;
      if (a && 'string' == typeof a) if (void 0 !== b) c._data || (c._data = {}), c._data[a] = b;else return c._data && c._data[a];
    }
  }, {
    key: "parseAndSetAttribute",
    value: function parseAndSetAttribute() {
      var a,
          b,
          c = this,
          d = c.rawConfig,
          e = c.getFromEnv('snapPoints'),
          f = pluckNumber(d.autoscale, d.autoScale, 1),
          g = {
        x: pluck(d.x, d.xPos, 0),
        y: pluck(d.y, d.yPos, 0),
        toX: pluck(d.toX),
        toY: pluck(d.toY)
      },
          h = c.config.calculatedAttrs = {},
          i = c.getScaleInfo();

      for (var j in g) {
        g.hasOwnProperty(j) && (b = g[j], 'undefined' != typeof b && (b = b.toString(), i.axis = j, isMacro(b) ? h[j] = solveEquation(parseEquation(cleanMacro(b.toLowerCase()), e, i)) : (h[j] = solveEquation(parseEquation(cleanMacro(b.toLowerCase()), e)), f && (h[j] = getScaledVal(h[j], i)))));
      }

      'group' !== c.config.elementType && (a = c.getLinkedParent().config.calculatedAttrs, h.x += a.x || 0, h.y += a.y || 0, isNaN(+h.toX) ? h.toX = h.x : h.toX += a.x || 0, !isNaN(+h.toY) && (h.toY += a.y || 0)), c.updateAttr();
    }
  }, {
    key: "getAttribute",
    value: function getAttribute() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return '' === a ? this.rawConfig : this.rawConfig[a];
    }
  }, {
    key: "show",
    value: function show() {
      var a = this;
      a.addGraphicalElement({
        el: a.config.elementType,
        attr: {
          visibility: hiddenStr
        },
        component: a,
        container: a.config.containerConfiguration,
        id: a.config.id,
        label: a.config.animationLabel
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      var a = this;
      a.addGraphicalElement({
        el: a.config.elementType,
        attr: {
          visibility: hiddenStr
        },
        component: a,
        container: a.config.containerConfiguration,
        id: a.config.id,
        label: a.config.animationLabel
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var a,
          b = this._getFromStore('originalComponent'),
          c = b.retrieveItem(this.config.id, !0);

      c && (a = b.getGraphicalElement(this.config.id), a && b.removeGraphicalElement(a));
    }
  }]);

  return AnnotationBase;
}(SmartRenderer);

export default AnnotationBase;